import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/lexus/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { BnbLabel } from "../../../utils/labels";
import type { ConfigCodeModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import TyCodeBlock from "../../common/TyCodeBlock";

const ConfigCodeModal = (props: ModalViewType<ConfigCodeModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show}>
            <Modal.Header>
                <Modal.Title isCentered>
                    <BnbLabel label="yourCode" />
                </Modal.Title>
                <Modal.Button type="button" onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body noSpacing>
                <TyCodeBlock />
            </Modal.Body>
        </ModalBaseView>
    );
};

export default ConfigCodeModal;
